<template>
    <div class="games">
        <slot v-if="isMobile">
            <Game>
                <template slot="title">Single Poker</template>
                <template slot="provider">XPRO Gaming</template>
                <template slot="img"><img src="https://severalreq.com/common/casino/xprogaming/texas_holdem.jpg"/></template>
                <template slot="play">
                    <a href="javascript:;" @click="runGame({id: '55223', device: isMobile})" class="button secondary">Hemen Oyna</a>
                </template>
            </Game>
            <Game>
                <template slot="title">Baccarat</template>
                <template slot="provider">XPRO Gaming</template>
                <template slot="img"><img src="https://severalreq.com/common/casino/xprogaming/baccarat.jpg"/></template>
                <template slot="play">
                    <a href="javascript:;" @click="runGame({id: '55225', device: isMobile})" class="button secondary">Hemen Oyna</a>
                </template>
            </Game>
        </slot>

        <div class="game" v-if="!isMobile">
            <div class="box">
                <div class="image">
                    <img src="https://severalreq.com/common/casino/xprogaming/texas_holdem.jpg"/>
                </div>
                <div class="info">
                    <h6>Single Poker</h6>
                    <p>XPRO Gaming</p>
                    <a href="javascript:;" @click="runGame({id: '55223', device: isMobile})" class="button secondary">Hemen Oyna</a>
                </div>
            </div>
            <div class="box">
                <div class="image">
                    <img src="https://severalreq.com/common/casino/xprogaming/baccarat.jpg"/>
                </div>
                <div class="info">
                    <h6>Baccarat</h6>
                    <p>XPRO Gaming</p>
                    <a href="javascript:;" @click="runGame({id: '55225', device: isMobile})" class="button secondary">Hemen Oyna</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { mapActions } from 'vuex'
    import Game from './Game'
    export default{
        data(){
            return{

            }
        },
        components:{
            Game
        },
        methods:{
            runGame(payload){
                if(!this.$auth()){
                this.$emit('loginModal', true);
                return false;
                }else{
                this.$store.dispatch('casino/runGame', payload)
                }
            }
        },
        computed:{
        }
    }
</script>